import '../App.css';
import Map from '../components/Map.js';

function MapRoute() {  
  return Map();
}

export default MapRoute;
